"use strict";

import _classCallCheck from "/Users/milespeyton/Documents/github/spiky/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/milespeyton/Documents/github/spiky/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/milespeyton/Documents/github/spiky/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/milespeyton/Documents/github/spiky/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/milespeyton/Documents/github/spiky/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Coder } from "./abstract-coder";
export var NullCoder = /*#__PURE__*/function (_Coder) {
  _inherits(NullCoder, _Coder);

  function NullCoder(localName) {
    _classCallCheck(this, NullCoder);

    return _possibleConstructorReturn(this, _getPrototypeOf(NullCoder).call(this, "null", "", localName, false));
  }

  _createClass(NullCoder, [{
    key: "defaultValue",
    value: function defaultValue() {
      return null;
    }
  }, {
    key: "encode",
    value: function encode(writer, value) {
      if (value != null) {
        this._throwError("not null", value);
      }

      return writer.writeBytes([]);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      reader.readBytes(0);
      return reader.coerce(this.name, null);
    }
  }]);

  return NullCoder;
}(Coder);